import * as React from 'react'
import { StoreProps } from '../../../../services/stores/casting.store'
import { TypedID } from '../../../../services/utils/iots.service'
import { Select } from '../../../shared/select.component'

export default class CastingPreferencesPickerComponent extends React.Component<StoreProps, never> {
  private removeThenAdd (removeId: TypedID<'ItemPreference'>, addId: TypedID<'ItemPreference'>) {
    const newSelection = this.props.data.selectedItemPreferenceIds.filter(_ => _ !== removeId)
    if (addId) newSelection.push(addId)
    this.props.store.set({ selectedItemPreferenceIds: newSelection })
  }

  render () {
    const { data: { offeredService: { preferences }, selectedItemPreferenceIds } } = this.props

    return <React.Fragment>
      { preferences.map((preference, index) => {
        switch (preference.preference_type) {
          case 'checkbox': {
            const firstItem = preference.item_preferences[0]

            return <div key={ index } className="inputCheckbox form-group">
              <input
                type="checkbox"
                id={ `preference-${firstItem.id}` }
                onChange={ evt => evt.target.checked ? this.removeThenAdd(null, firstItem.id) : this.removeThenAdd(firstItem.id, null) }
                checked={ selectedItemPreferenceIds.includes(firstItem.id) } />
              <label htmlFor={ `preference-${firstItem.id}` }>{ preference.name }</label>
            </div>
          }

          case 'dropdown': {
            const currentlySelected = preference.item_preferences.find(_ => selectedItemPreferenceIds.includes(_.id))

            return <div key={ index } className="form-group">
              <label>{ preference.name }</label>
              <Select
                value={ currentlySelected }
                options={ preference.item_preferences }
                getOptionLabel={ val => val.name }
                getOptionValue={ val => val.id.toString() }
                placeholder={ preference.name }
                onChange={ val => this.removeThenAdd(currentlySelected?.id, val?.id) }
                isClearable
                isSearchable={ false } />
            </div>
          }
        }
      }) }
    </React.Fragment>
  }
}
